import styled from "@emotion/styled";
import IconWrapper from "metabase/components/IconWrapper";
import Icon from "metabase/components/Icon";

export const ItemIcon = styled(Icon)`
  display: block;
`;

export const ItemIconContainer = styled(IconWrapper)`
  padding: 0.5rem;
  margin-right: 0.5rem;
  line-height: 1;
`;
